<template>
    <div class="sa-list-component">
        <div class="sa-list-component-body">
            <div class="b-table-sticky-header">
                <span class="sa-flexbox-body-title">Schede di Valutazione</span>
                <!--secondary btn-toolbar sa-margin-right float-sm-right-->
                <!--    <b-button size="sm" variant="outline-success outline-primary-noborder sa-margin-right float-sm-right" :hidden="btnAggiungi" @click="onClickAggiungi" class="mb-2">
                    <i class="fas fa-plus"></i>
                    Aggiungi
                </b-button> -->
                <b-table sticky-header ref="table" stacked="lg" striped hover :items="items" :fields="fields" :current-page="1" :per-page="perPage" sort-icon-left head-variant="light" class="sa-b-table">
                    <template v-slot:cell(dataOraCompilazione)="{ item }">
                        <span>{{ formatDateTime(item.createDate) }}</span>
                    </template>
                    <template v-slot:cell(autore)="{ item }">
                        <span>{{ item.createUser }}</span>
                    </template>
                    <template #cell(action)="{ item }">
                        <b-button size="sm" variant="outline-secondary" @click="onClickVisualizzaScheda(item)" title="Visualizza">
                            <font-awesome-icon icon="eye" />
                        </b-button>
                        <b-container class="bv-example-row">
                            <print-component :documentRepository="true" :idRisorsa="item.id" :typeButton="'small'"> </print-component>
                            <!-- <b-button size="sm" variant="outline-secondary" @click="onClickStampa(item)" title="Visualizza">
                                <font-awesome-icon icon="eye"  color="red"/>
                            </b-button> -->
                            <!--  
                            <b-button :disabled="!item.tipoScheda || (item.tipoScheda.trim() !== 'SCHEDA RELAZIONE SANITARIA' && item.tipoScheda !== 'ANAMNESI / STORIA CLINICA')" size="sm" variant="outline-success" @click="onClickModificaScheda(item)" title="Modifica">
                                <font-awesome-icon icon="edit" />
                            </b-button>
                            <b-button size="sm" variant="outline-danger" @click="onClickDeleteScheda(item)" title="Elimina">
                                <font-awesome-icon icon="trash" />
                            </b-button> -->
                        </b-container>
                    </template>
                </b-table>
            </div>
        </div>
        <div class="sa-list-component-footer">
            <b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
                <b-col lg="3">
                    <p>{{ this.$i18n.t("patients.lblTotalRecords") }}: {{ rows }}</p>
                </b-col>
                <b-col lg="9">
                    <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="right" size="sm"></b-pagination>
                </b-col>
            </b-row>
        </div>
        <!-- <print-component v-show="false" ref="cmpPrint"></print-component> -->
        <modal-error ref="cmpModalError"></modal-error>
        <b-modal :title="dynamicJsonData.titolo" ref="mdlDynamicForm" size="lg" @shown="onShownDynamicForm" @ok="onOkDynamicForm" scrollable>
            <dynamic-form ref="cmpDynamicForm" :jsonData="dynamicJsonData" :isView="true"></dynamic-form>
        </b-modal>
    </div>
</template>

<script>
import axios from "axios";
import UtilityMixin from "../../../utility/UtilityMixin";
import PrintComponent from "../../../utility/components/PrintComponent.vue";
import ModalError from "../../../../template/components/modal/components/ModalError.vue";
import DynamicForm from "../../../utility/components/DynamicForm.vue";
export default {
    mixins: [UtilityMixin],
    components: { PrintComponent, ModalError, DynamicForm },
    inject: ["openShowModalLoading", "closeShowModalLoading"],
    data() {
        return {
            rows: 0,
            perPage: 50,
            currentPage: 1,
            pathResource: "/rsaschedevalutazionepazientetestata",
            pathResourceDynamicForm: "/dynamicform",
            btnAggiungi: false,
            filtroSchedeValutazione: { idAccettazione: null },
            schedaValutazioneSelezionata: {},
            defaultValues: {},
            idAccettazione: "",
            items: [],
            dynamicJsonData: {},
            jsonDataAccettazione: {},
            fields: [
                { label: "Tipo", key: "tipologia", sortable: true, thStyle: "width: 18rem" },
                { label: "Data/Ora Compilazione", key: "dataOraCompilazione", sortable: true, thStyle: "width: 18rem" },
                { label: "Autore", key: "autore", sortable: true, thStyle: "width: 18rem" },
                { label: "", key: "action", class: "sa-table-column-action-double" },
            ],
        };
    },
    watch: {
        currentPage() {
            let me = this;
            me.loadData();
        },
    },
    methods: {
        init(jsonDataAccettazione) {
            let me = this;
            if (sessionStorage["filtroSchedeValutazione"]) {
                me.filtroSchedeValutazione = JSON.parse(sessionStorage["filtroSchedeValutazione"]);
            }
            me.jsonDataAccettazione = jsonDataAccettazione;
            me.idAccettazione = jsonDataAccettazione.id;
            me.filtroSchedeValutazione.idAccettazione = me.idAccettazione;
            me.loadData();
        },
        loadData() {
            let me = this;
            me.filtroSchedeValutazione.page = me.currentPage;
            me.filtroSchedeValutazione.forPage = me.perPage;
            me.openShowModalLoading();
            UtilityMixin.methods.loadDataResources(me.pathResource, me.filtroSchedeValutazione, me.loadDataSuccess, me.loadDataError);
        },
        loadDataSuccess(response) {
            let me = this;
            me.items = response.data.data.list;
            me.rows = response.data.data.recordsNumber;
            me.closeShowModalLoading();
        },
        loadDataError(error) {
            let me = this;
            console.log(error);
            me.closeShowModalLoading();
        },
        onClickVisualizzaScheda(item) {
            let me = this;
            me.schedaValutazioneSelezionata = item;
            me.loadDinamicFormView(item.idForm);
        },
        loadDinamicFormView(idForm) {
            let me = this;
            //  me.$refs.cmpModalLoading.show();
            UtilityMixin.methods.loadDataResources(me.pathResourceDynamicForm + "/" + idForm, {}, me.loadDinamicFormViewSuccess, me.loadDinamicFormViewError);
        },
        loadDinamicFormViewSuccess(response) {
            let me = this;
            if (response.data.data.pathModule) {
                //  me.$refs.cmpModalLoading.close();
                let dynamicJsonData = response.data.data;
                dynamicJsonData.jsonForm = JSON.parse(response.data.data.jsonForm);
                me.dynamicJsonData = dynamicJsonData;
                let link = process.env.VUE_APP_PATH_API + response.data.data.pathModule + "/attivita/" + me.schedaValutazioneSelezionata.idAttivita;
                axios
                    .get(link)
                    .then((response) => {
                        me.defaultValues = response.data.data;
                        me.defaultValues.ospite = me.jsonDataAccettazione.accettazioneAnagrafica.nome + " " + me.jsonDataAccettazione.accettazioneAnagrafica.cognome;
                        me.defaultValues.educatore = me.schedaValutazioneSelezionata.createUser;
                        me.defaultValues.numero = me.jsonDataAccettazione.numero;
                        me.defaultValues.dataNascita = me.formatDate(me.jsonDataAccettazione.accettazioneAnagrafica.dataNascita);
                        me.$refs.mdlDynamicForm.show();
                    })
                    .catch((error) => {
                        let messaggio = error.response ? error.response.data.messaggio : "Errore non gestito";
                        if (!messaggio) {
                            messaggio = error.message;
                        }
                        this.$bvModal
                            .msgBoxOk(messaggio, {
                                title: "ATTENZIONE",
                                size: "sm",
                                okVariant: "outline-danger",
                                headerBgVariant: "danger",
                                centered: true,
                            })
                            .then((value) => {
                                console.log(value);
                            })
                            .catch(() => {});
                    });
            } else {
                me.$bvModal.msgBoxOk("Path del modulo non configurato", {
                    title: "ATTENZIONE",
                    size: "sm",
                    okVariant: "outline-danger",
                    headerBgVariant: "danger",
                    centered: true,
                });
            }
        },
        loadDinamicFormViewError(error) {
            console.log(error);
        },
        onClickStampa(item) {
            let me = this;
            let path = me.getPathResourcesPrint(item.tipoScheda);
            me.loadDataResources(path + "/printdata/" + item.id, null, me.resulResponseStampa, me.resulErrorStampa);
        },
        resulResponseStampa(response) {
            let me = this;
            me.$refs.cmpPrint.print(response.data.data);
        },
        resulErrorStampa(error) {
            console.log(error);

            // let messaggio = "errore";
        },
        onShownDynamicForm() {
            let me = this;
            me.$refs.cmpDynamicForm.setForm(me.defaultValues);
        },
        onOkDynamicForm() {
            let me = this;
            me.$refs.mdlDynamicForm.hide();
        },
    },
};
</script>

<style></style>
